import {
  GET_PERSONNELS,
  GET_PERSONNELS_SUCCESS,
  GET_PERSONNELS_FAILURE,
  ADD_PERSONNEL,
  ADD_PERSONNEL_SUCCESS,
  ADD_PERSONNEL_FAILURE,
  EDIT_PERSONNEL,
  EDIT_PERSONNEL_SUCCESS,
  EDIT_PERSONNEL_FAILURE,
  DELETE_PERSONNEL,
  DELETE_PERSONNEL_SUCCESS,
  DELETE_PERSONNEL_FAILURE,
  GET_SINGLE_PERSONNEL,
  GET_SINGLE_PERSONNEL_SUCCESS,
  GET_SINGLE_PERSONNEL_FAILURE,
  CHANGE_AVAILABILITY_STATUS,
  CHANGE_AVAILABILITY_STATUS_SUCCESS,
  CHANGE_AVAILABILITY_STATUS_FAILURE,
} from "./actionTypes";

export const getPersonnels = () => {
  return {
    type: GET_PERSONNELS,
  };
};

export const getPersonnelsSuccess = (country) => {
  return {
    type: GET_PERSONNELS_SUCCESS,
    payload: country,
  };
};

export const getPersonnelsFailure = (error) => {
  return {
    type: GET_PERSONNELS_FAILURE,
    payload: error,
  };
};

export const getSinglePersonnel = (id) => {
  return {
    type: GET_SINGLE_PERSONNEL,
    payload: id,
  };
};

export const getSinglePersonnelSuccess = (country) => {
  return {
    type: GET_SINGLE_PERSONNEL_SUCCESS,
    payload: country,
  };
};

export const getSinglePersonnelFailure = (error) => {
  return {
    type: GET_SINGLE_PERSONNEL_FAILURE,
    payload: error,
  };
};

export const addPersonnel = (payload) => {
  return {
    type: ADD_PERSONNEL,
    payload,
  };
};

export const addPersonnelSuccess = (payload) => {
  return {
    type: ADD_PERSONNEL_SUCCESS,
    payload,
  };
};

export const addPersonnelFailure = (error) => {
  return {
    type: ADD_PERSONNEL_FAILURE,
    payload: error,
  };
};

export const editPersonnel = (payload) => {
  return {
    type: EDIT_PERSONNEL,
    payload,
  };
};

export const editPersonnelSuccess = (payload) => {
  return {
    type: EDIT_PERSONNEL_SUCCESS,
    payload,
  };
};

export const editPersonnelFailure = (error) => {
  return {
    type: EDIT_PERSONNEL_FAILURE,
    payload: error,
  };
};

export const deletePersonnel = (id) => {
  return {
    type: DELETE_PERSONNEL,
    payload: id,
  };
};

export const deletePersonnelSuccess = (id) => {
  return {
    type: DELETE_PERSONNEL_SUCCESS,
    payload: id,
  };
};

export const deletePersonnelFailure = (error) => {
  return {
    type: DELETE_PERSONNEL_FAILURE,
    payload: error,
  };
};

export const changeAvailabilityStatus = (payload) => {
  return {
    type: CHANGE_AVAILABILITY_STATUS,
    payload,
  };
};

export const changeAvailabilityStatusSuccess = (payload) => {
  return {
    type: CHANGE_AVAILABILITY_STATUS_SUCCESS,
    payload,
  };
};

export const changeAvailabilityStatusFailure = (error) => {
  return {
    type: CHANGE_AVAILABILITY_STATUS_FAILURE,
    payload: error,
  };
};
